import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FeatureArt from "./FeatureArt";
import { featurePath } from "../data/features";

const TILE =
  "group flex h-full flex-col items-center rounded-3xl px-2 pb-4 text-center transition-transform duration-300 ease-out hover:-translate-y-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6B00]/50 focus-visible:ring-offset-4";

// Feature tile: floating round artwork over centred text, linking to the
// feature's detail page. `big` is the larger variant for the channel rows.
export default function FeatureOrb({ cat, big = false, testId = "feature-orb" }) {
  return (
    <Link to={featurePath(cat)} data-testid={testId} className={TILE}>
      <FeatureArt
        cat={cat}
        alt={`${cat.title} - MagicBolt AI automation`}
        className={big ? "max-w-[280px]" : "max-w-[200px]"}
      />

      {cat.tag && cat.tag !== cat.title && (
        <div className={`mt-3 font-semibold uppercase tracking-[0.14em] text-[#94A3B8] ${big ? "text-xs" : "text-[11px]"}`}>
          {cat.tag}
        </div>
      )}
      <h3
        className={`mt-1.5 break-words font-bold leading-snug text-[#0B1533] ${big ? "text-lg xl:text-xl" : "text-sm sm:text-base"}`}
      >
        {cat.title}
        {cat.comingSoon && <span className="ml-1.5 text-xs font-medium text-[#94A3B8]">· Soon</span>}
      </h3>
      {big && (
        <p className="mt-2 max-w-[280px] text-sm leading-relaxed text-[#475569] line-clamp-3">{cat.intro}</p>
      )}
      <span
        className={`mt-auto inline-flex items-center gap-1 pt-3 font-semibold text-[#FF6B00] ${big ? "text-sm" : "text-xs sm:text-sm"}`}
      >
        Explore
        <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-1" />
      </span>
    </Link>
  );
}

// Artwork for the "Many More" tiles, in the shape FeatureArt expects.
export const MORE_ART = { cardImage: "/many-more.webp", accent: { color: "#FF6B00" } };

// Closing tile at the end of a grid - points to a fuller list instead of a
// single feature.
export function MoreOrb({ to, label, testId = "feature-orb-more" }) {
  return (
    <Link to={to} data-testid={testId} className={TILE}>
      <FeatureArt cat={MORE_ART} className="max-w-[200px]" />
      <h3 className="mt-3 text-sm font-bold leading-snug text-[#0B1533] sm:text-base">Many More</h3>
      <span className="mt-auto inline-flex items-center gap-1 pt-3 text-xs font-semibold text-[#FF6B00] sm:text-sm">
        {label}
        <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
